import React from "react";

type Difficulty = "easy" | "medium" | "hard" | string;

type Props = {
  children: React.ReactNode;
  /** Color-codes the badge by tour difficulty (easy/medium/hard). */
  difficulty?: Difficulty;
  className?: string;
};

const difficultyColor: Record<string, string> = {
  easy: "text-easy",
  medium: "text-medium",
  hard: "text-hard",
};

/**
 * Rounded pill badge over card imagery, e.g. "EASY · 5 DAYS".
 * Semi-opaque sand background; text color keyed to difficulty.
 */
const Badge = ({ children, difficulty, className = "" }: Props) => {
  const color = difficulty
    ? difficultyColor[difficulty.toLowerCase()] ?? "text-secondary-400"
    : "text-secondary-400";
  return (
    <span
      className={`inline-block rounded-full bg-sand/90 px-3 py-1.5 text-[12px] font-bold ${color} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
